import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Plans.css';

const Plans = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Välj Plan - TrafikBevakning';
    window.scrollTo(0, 0);
  }, []);

  const handleSelectPlan = (planType) => {
    navigate('/checkout', { state: { plan: planType } });
  };

  return (
    <div className="plans-wrapper">
      <div className="plans-container">
        <div className="plans-header">
          <h1 className="plans-title">Välj din plan</h1>
          <p className="plans-subtitle">
            Hitta lediga tider snabbare med våra smarta verktyg. Välj den nivå som passar dig bäst.
          </p>
        </div>

        <div className="plans-grid">
          {/* Basic Plan */}
          <div className="plan-card">
            <h3 className="plan-name">Bevakning</h3>
            <div className="plan-price">
              99 kr <span className="plan-period">/månad</span>
            </div>
            <ul className="plan-features">
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Sök automatiskt efter lediga tider hos Trafikverket
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Få notiser direkt när en tid hittas
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Upp till 300 timmar automatisk bevakning/månad
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Bevaka dygnet runt
              </li>
            </ul>
            <button className="plan-button basic" onClick={() => handleSelectPlan('basic')}>
              Välj Bevakning
            </button>
          </div>

          {/* Premium Plan */}
          <div className="plan-card premium">
            <div className="popular-badge">Populärast</div>
            <h3 className="plan-name">Auto-Bokning</h3>
            <div className="plan-price">
              199 kr <span className="plan-period">/månad</span>
            </div>
            <ul className="plan-features">
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Allt som ingår i Bevakning
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                <span>
                  <strong>Automatisk bokning </strong> av lediga tider
                </span>
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Bokar automatiskt om till tidigare tider
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Avbokar din gamla tid automatiskt
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Upp till 300 timmar automatisk bevakning/månad
              </li>
              <li className="feature-item">
                <span className="feature-icon">✓</span>
                Maximal chans att få körkort snabbare
              </li>
            </ul>
            <button className="plan-button premium" onClick={() => handleSelectPlan('premium')}>
              Välj Auto-Bokning
            </button>
          </div>

          {/* Pro / Unlimited Plan */}
          <div className="plan-card pro">
            <div className="pro-badge">Kampanj: 50% Rabatt</div>
            <h3 className="plan-name">Auto-Bokning Pro</h3>
            <div className="plan-price-wrapper">
              <div className="plan-price highlight-price">
                <span className="plan-original-price">300 kr</span>
                <span className="plan-current-price">150 kr</span>
              </div>
              <div className="plan-period-highlight">/första månaden</div>
              <div className="plan-price-subtext">Därefter 300 kr/månad. Avbryt när som helst.</div>
            </div>
            <ul className="plan-features">
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                <span>
                  <strong>Allt som ingår i Auto-Bokning</strong>
                </span>
              </li>
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                <span>
                  <strong>Obegränsad bevakningstid</strong> (ingen 300h-gräns!)
                </span>
              </li>
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                <span>
                  <strong>Automatisk bokning </strong> direkt när tider släpps
                </span>
              </li>
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                Bokar kontinuerligt om till ännu tidigare tider
              </li>
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                Högsta prioritet & kontinuerlig övervakning dygnet runt
              </li>
              <li className="feature-item">
                <span className="feature-icon highlight-icon">✓</span>
                Snabbast möjliga väg till uppkörning och körkort
              </li>
            </ul>
            <button className="plan-button pro" onClick={() => handleSelectPlan('pro')}>
              Välj Auto-Bokning Pro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
